import { useMutateContactAddress } from './useMutateContactAddress'

export const useProcessContactAddress = () => {
  const {
    createContactAddressMutation,
    updateContactAddressMutation,
    updateContactAddressFavoriteMutation,
    deleteContactAddressMutation,
  } = useMutateContactAddress()

  const registContactAddress = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    contactAddress: any,
  ) => {
    e.preventDefault()
    createContactAddressMutation.mutate(contactAddress)
  }

  const updateContactAddress = async (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLSpanElement, MouseEvent>,
    contactAddress: any,
  ) => {
    e.preventDefault()
    updateContactAddressMutation.mutate(contactAddress)
  }

  const updateContactAddressFavorite = async (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLSpanElement, MouseEvent>,
    contactAddress: any,
  ) => {
    e.preventDefault()
    updateContactAddressFavoriteMutation.mutate(contactAddress)
  }

  const deleContactAddress = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    id: number,
  ) => {
    e.preventDefault()
    deleteContactAddressMutation.mutate(id)
  }

  return {
    registContactAddress,
    updateContactAddress,
    updateContactAddressFavorite,
    deleContactAddress,
  }
}
